import get from 'lodash/get';

const styles = ({ color }) => ({
  emailContainer: {
    marginTop: '0px !important',
    width: 460,
  },
  emailSearchDialogPaper: {
    width: 600,
  },
  emailSearchField: {
    width: 480,
  },
  organizations: {
    width: 250,
  },
  saveButton: {
    marginTop: 10,
  },
  topRow: {
    display: 'flex',
  },
  userContainer: {
    display: 'flex',
  },
  userHeaderRow: {
    borderBottom: `1px solid ${get(color, 'primaryButtonBackground')}`,
    color: get(color, 'bodyText'),
    fontWeight: 'bold',
    paddingBottom: 8,
    paddingLeft: 42,
    paddingTop: 8,
  },
  userName: {
    width: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  userRow: {
    borderBottom: `1px solid ${get(color, 'primaryButtonBackground')}`,
    paddingLeft: 10,
  },
});

export default styles;
